import { render, staticRenderFns } from "./nian-du-wang-luo-ling-shou.vue?vue&type=template&id=d463b8b0&scoped=true"
import script from "./nian-du-wang-luo-ling-shou.vue?vue&type=script&lang=js"
export * from "./nian-du-wang-luo-ling-shou.vue?vue&type=script&lang=js"
import style0 from "./nian-du-wang-luo-ling-shou.vue?vue&type=style&index=0&id=d463b8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d463b8b0",
  null
  
)

export default component.exports